/*@ngInject*/
const RemoteFunctionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.executeFunction = function (formId, submissionId, beanName, fieldId, paramMap) {
        let url = ('/rest/Form/' +
            formId +
            '/executor?beanName=' +
            beanName +
            (submissionId ? '&submissionId=' + submissionId : '') +
            (fieldId ? '&fieldId=' + fieldId : ''));
        return this.post(url, paramMap);
    };
};

angular.module('umFormViewer')
    .service('remoteFunctionRepository', RemoteFunctionRepository);
